import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import Footer from "../../Components/Footer/Footer";
import feedbackimage from "./Assets/feedbackimage.svg";
import { GetFeedbackPageData, UpdateFeedbackDataInDatabase } from "../../Actions/StudentA";
import { BaseUrl } from "../../Actions/Base";
import { GetLocalStorage } from "../../Helpers/LocalStorage/LocalStorage";
import SettingsPopup from "../Settings/Popups/Popups";
import questionsData from "../../JsonFiles/FeedBackQuestions.json"

const EnrolledCourseFeedback = () => {
    const { EnrollmentId } = useParams();
    console.log("EnrollmentId in useparams is:",EnrollmentId);

    const UserId =  GetLocalStorage("UserInfo")?.UserId;
    console.log("UserId in EnrolledCourseFeedback:",UserId)

    const [ratings, setRatings] = useState({});  // Stores instructor ratings
    const [instituteRating, setInstituteRating] = useState(0);
    const [courseRating, setCourseRating] = useState(0);
    const [courseReview, setCourseReview] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const Dispatch = useDispatch();
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    const { FeedbackPagedata } = useSelector(Store => Store.StudentReducer);
    console.log("FeedbackPagedata in EnrolledCourseFeedback is:",FeedbackPagedata)

    useEffect(() => {
        if(EnrollmentId){
            Dispatch(GetFeedbackPageData(EnrollmentId));
        }
      }, [Dispatch, EnrollmentId]);

      const formatDate = (dateString) => {
        if (!dateString) return "Invalid Date";
      
        return new Date(dateString).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }).replace(/\//g, " / ");
      };

      const handleRating = (instructorId, classType, questionIndex, rating) => {
        setRatings((prevRatings) => ({
            ...prevRatings,
            [`${instructorId}__${classType}`]: {  // Use double underscore `__` for a clear split
                ...prevRatings[`${instructorId}__${classType}`],
                [questionIndex]: rating
            }
        }));
    };    
    
      const handleInstituteRating = (rating) => {
        setInstituteRating(rating);
       };
    
        const handleCourseRating = (rating) => {
            setCourseRating(rating);
        };
        
        const handleCourseReview = (e) => {
            setCourseReview(e.target.value);
        };

        const computeInstructorAverages = () => {
            return Object.entries(ratings).map(([key, responses]) => {
                const splitKey = key.split("__"); // Use double underscore as separator
                const instructorId = splitKey[0]; 
                const classType = splitKey.slice(1).join("__"); // Preserve full class type in case of dashes
        
                const total = Object.values(responses).reduce((acc, val) => acc + val, 0);
                const average = total / Object.keys(responses).length;
        
                return {
                    InstructorFK: instructorId,
                    InstructorRating: Math.round(average),  // Rounded average
                    ClassType: classType
                };
            });
        };    

        const handleSubmit = () => {
            const instructorFeedback = computeInstructorAverages();
            
            const feedbackPayload = [
                ...instructorFeedback.map(feedback => ({
                    FeedbackId: crypto.randomUUID(),
                    UserFK: UserId,  // Get this from Redux or Context
                    InstructorFK: feedback.InstructorFK,
                    InstructorRating: feedback.InstructorRating,
                    ClassType: feedback.ClassType
                })),
                {
                    FeedbackId: crypto.randomUUID(),
                    UserFK: UserId,
                    InstituteFK: FeedbackPagedata?.InstituteId,
                    InstituteRating: instituteRating
                },
                {
                    FeedbackId: crypto.randomUUID(),
                    UserFK: UserId,
                    InstituteCourseFK: FeedbackPagedata?.InstituteCourseId,
                    CourseRating: courseRating,
                    CourseReview: courseReview
                }
            ];
            console.log("feedbackPayload is:",feedbackPayload)
            // Dispatch(UpdateFeedbackDataInDatabase(feedbackPayload))
            Dispatch(UpdateFeedbackDataInDatabase(feedbackPayload, EnrollmentId))
            .then(() => {
                setShowPopup(true); // Show popup on successful update
                // Reset states after submission
                setInstituteRating(null);  // Reset institute rating
                setCourseRating(null);      // Reset course rating
                setCourseReview("");        // Reset course review
                setRatings({});  // Reset instructor feedback if needed

                setTimeout(() => {
                    window.location.href = `${window.location.origin}/`; // Redirect to the main page
                }, 5000);
                
            })
            .catch(error => {
                console.error("Error submitting feedback:", error);
            });
        };

        const isSubmitDisabled = () => {
            const allInstructorsRated = FeedbackPagedata?.instructors?.every(instructor =>
                ratings[`${instructor.InstructorFK}__${instructor.ClassType}`] &&
                Object.keys(ratings[`${instructor.InstructorFK}__${instructor.ClassType}`]).length === 3
            );
        
            return !(allInstructorsRated && instituteRating > 0 && courseRating > 0 && courseReview.trim() !== "");
        };
        

    return(
        <>
        {FeedbackPagedata.Status !== "Completed" ? (
            <>
                <div className="mt-[120px] w-full flex justify-center items-center ">
                <div className="w-[90%] flex justify-between">
                    <div className="w-[60%] flex flex-col gap-[10px]">
                            <p className="text-[40px] text-[#290A69] font-bold">Public Feedback</p>
                            <p className="text-[22px] text-[#290A69] w-[650px]"
                        >
                                Share your experience with this course, to help us make better decisions in future. Rate your experience between 1 to 5 Where 1 is the least and 5 is the most
                            </p>

                            {FeedbackPagedata?.instructors?.map((instructor) => (
                                <div
                                    key={instructor.InstructorFK}
                                    className="w-full flex flex-col gap-[10px] py-[10px]"
                                    style={{ borderBottom: "1px solid #D6D6D6" }}
                                >
                                    <p className="text-[26px] text-[#290A69] font-bold">
                                            {instructor.FirstName} {instructor.LastName} - {instructor.ClassType === "Driving" ? "In-Vehicle" : instructor.ClassType === "InClass" ? "In-Class" : instructor.ClassType} Classes
                                    </p>

                                    {questionsData.instructorQuestions.map((question, index) => (
                                        <div key={index} className="w-full flex justify-between items-center">
                                            <p className="text-[18px] text-[#290A69]">{index + 1}. {question}</p>
                                            <div className="flex gap-[5px]">
                                                {[1, 2, 3, 4, 5].map((star) => (
                                                    <FaStar
                                                        key={star}
                                                        className={`cursor-pointer text-[25px] ${
                                                            star <= (ratings?.[`${instructor.InstructorFK}__${instructor.ClassType}`]?.[index] || 0)
                                                                ? "text-[#290A69]" // Filled star color
                                                                : "text-[#A1A3EF]"  // Empty star color
                                                        }`}
                                                        onClick={() => handleRating(instructor.InstructorFK, instructor.ClassType, index, star)}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}

                            {/* Institute Rating Section */}
                            <div className="w-full flex flex-col gap-[10px] py-[10px]"
                            style={{
                                borderBottom:"1px solid #D6D6D6",
                            }}>
                                <p className="text-[26px] text-[#290A69] font-bold">Institute Rating</p>
                                <div className="w-full flex justify-between items-center">
                                    <p className="text-[18px] text-[#290A69]">How much satisfied are you with the institute.</p>
                                    <div className="flex gap-[5px]">
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <FaStar
                                                key={star}
                                                className={`cursor-pointer text-[25px] ${star <= instituteRating ? "text-[#290A69]" : "text-[#A1A3EF]"}`}
                                                onClick={() => handleInstituteRating(star)}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="w-full flex flex-col gap-[10px] py-[10px]"
                            style={{
                                borderBottom:"1px solid #D6D6D6",
                            }}>
                                <p className="text-[26px] text-[#290A69] font-bold">Course Rating</p>
                                <div className="w-full flex justify-between items-center">
                                    <p className="text-[18px] text-[#290A69]">How much satisfied are you with this course.</p>
                                    <div className="flex gap-[5px]">
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <FaStar
                                                key={star}
                                                className={`cursor-pointer text-[25px] ${star <= courseRating ? "text-[#290A69]" : "text-[#A1A3EF]"}`}
                                                onClick={() => handleCourseRating(star)}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="w-full flex flex-col gap-[10px] py-[10px]"
                            >
                                <p className="text-[26px] text-[#290A69] font-bold">Overall Course Review</p>
                                <textarea
                                className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029]`}
                                style={{ height: "150px", resize: "none" }}
                                value={courseReview}
                                onChange={handleCourseReview}
                                ></textarea>
                            </div>

                            <div className="w-full flex justify-end lg:mt-[10px]">
                            <button className={`w-[180px] h-[44px] rounded-[8px] text-[20px] 
                            ${isSubmitDisabled() ? "bg-gray-400 text-[#FFFFFF] cursor-not-allowed" : "bg-[#A1A3EF] cursor-pointer text-[#FFFFFF]"}`}
                            disabled={isSubmitDisabled()}
                            onClick={handleSubmit} >
                                Submit Feedback
                            </button>
                        </div>
                    </div>

                    <div className="w-[30%] mt-[150px]">
                        <div className="flex flex-col gap-[10px] p-[20px] bg-[#FFFFFF] shadow-[0px_0px_6px_#00000029] rounded-[20px]">
                            {/* <img src={feedbackimage} alt="image" /> */}
                            <img className="w-full h-[200px] object-cover" 
                                    src={`${BaseUrl}/api/LicenseType/Image?url=${FeedbackPagedata.courseThumbnail}`}
                                    alt="Courseimg" />
                            <p className="text-[18px] text-[#3B3735] font-bold text-center pb-[10px] mt-[10px]"
                            style={{
                                borderBottom:"1px solid #D6D6D6",
                            }}>{FeedbackPagedata ? FeedbackPagedata?.courseName : "Automotive"}</p>
                            <div className="w-full flex justify-between">
                                <p className="text-[18px] text-[#3B3735] font-bold ">Course Start Date:</p>
                                <p className="text-[18px] text-[#3B3735] ">  {FeedbackPagedata ? formatDate(FeedbackPagedata.courseStartDate) : "15 / 03 / 2024"}</p>
                            </div>
                            <div className="w-full flex justify-between">
                                <p className="text-[18px] text-[#3B3735] font-bold ">Course End Date:</p>
                                <p className="text-[18px] text-[#3B3735] ">{FeedbackPagedata ? formatDate(FeedbackPagedata.courseEndDate) : "15 / 03 / 2024"}</p>
                            </div>
                            <div className="w-full flex justify-between">
                                <p className="text-[18px] text-[#3B3735] font-bold ">Fee:</p>
                                <p className="text-[18px] text-[#3B3735] ">{FeedbackPagedata ? `$ ${FeedbackPagedata.totalFee}` : "$ 600"}</p>
                            </div>
                        </div>
                    </div>
                </div>
                </div>

                {showPopup && <SettingsPopup setShowPopup={setShowPopup} text="Feedback Saved Successfully." />}

                <Footer />
            </>
        ) : (
            <div className="mt-[120px] flex justify-center">
                <p className="text-[22px] text-[#290A69] w-[650px]">
                    You have already submitted your Feedback for this course.
                </p>
            </div>
        )}
        
        </>
    )
}

export default EnrolledCourseFeedback;



{/* <div className="w-full flex flex-col gap-[10px] py-[10px]"
                         style={{
                            borderTop:"1px solid #D6D6D6",
                            borderBottom:"1px solid #D6D6D6",
                        }}>
                            <p className="text-[26px] text-[#290A69] font-bold">John Doe - In-Vehicle Classes</p>
                            <div className="w-full flex justify-between items-center">
                                <p className="text-[18px] text-[#290A69]">1. How much did you liked the style of instructor.</p>
                                <div className="flex gap-[5px]">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <FaStar
                                            key={star}
                                            className={`cursor-pointer text-[25px] ${
                                            star <= rating ? "text-[#290A69]" : "text-[#A1A3EF]"
                                            }`}
                                            onClick={() => setRating(star)}
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="w-full flex justify-between items-center">
                                <p className="text-[18px] text-[#290A69]">2. How well prepared was the instructor before class.</p>
                                <div className="flex gap-[5px]">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <FaStar
                                            key={star}
                                            className={`cursor-pointer text-[25px] ${
                                            star <= rating ? "text-[#290A69]" : "text-[#A1A3EF]"
                                            }`}
                                            onClick={() => setRating(star)}
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="w-full flex justify-between items-center">
                                <p className="text-[18px] text-[#290A69]">3. How punctual was your instructor for class.</p>
                                <div className="flex gap-[5px]">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <FaStar
                                            key={star}
                                            className={`cursor-pointer text-[25px] ${
                                            star <= rating ? "text-[#290A69]" : "text-[#A1A3EF]"
                                            }`}
                                            onClick={() => setRating(star)}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="w-full flex flex-col gap-[10px] py-[10px]"
                         style={{
                            borderBottom:"1px solid #D6D6D6",
                        }}>
                            <p className="text-[26px] text-[#290A69] font-bold">Adam John - In-Class Classes</p>
                            <div className="w-full flex justify-between items-center">
                                <p className="text-[18px] text-[#290A69]">1. How much did you liked the style of instructor.</p>
                                <div className="flex gap-[5px]">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <FaStar
                                            key={star}
                                            className={`cursor-pointer text-[25px] ${
                                            star <= rating ? "text-[#290A69]" : "text-[#A1A3EF]"
                                            }`}
                                            onClick={() => setRating(star)}
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="w-full flex justify-between items-center">
                                <p className="text-[18px] text-[#290A69]">2. How well prepared was the instructor before class.</p>
                                <div className="flex gap-[5px]">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <FaStar
                                            key={star}
                                            className={`cursor-pointer text-[25px] ${
                                            star <= rating ? "text-[#290A69]" : "text-[#A1A3EF]"
                                            }`}
                                            onClick={() => setRating(star)}
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="w-full flex justify-between items-center">
                                <p className="text-[18px] text-[#290A69]">3. How punctual was your instructor for class.</p>
                                <div className="flex gap-[5px]">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <FaStar
                                            key={star}
                                            className={`cursor-pointer text-[25px] ${
                                            star <= rating ? "text-[#290A69]" : "text-[#A1A3EF]"
                                            }`}
                                            onClick={() => setRating(star)}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="w-full flex flex-col gap-[10px] py-[10px]"
                         style={{
                            borderBottom:"1px solid #D6D6D6",
                        }}>
                            <p className="text-[26px] text-[#290A69] font-bold">Hassan Ali - Other Classes</p>
                            <div className="w-full flex justify-between items-center">
                                <p className="text-[18px] text-[#290A69]">1. How much did you liked the style of instructor.</p>
                                <div className="flex gap-[5px]">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <FaStar
                                            key={star}
                                            className={`cursor-pointer text-[25px] ${
                                            star <= rating ? "text-[#290A69]" : "text-[#A1A3EF]"
                                            }`}
                                            onClick={() => setRating(star)}
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="w-full flex justify-between items-center">
                                <p className="text-[18px] text-[#290A69]">2. How well prepared was the instructor before class.</p>
                                <div className="flex gap-[5px]">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <FaStar
                                            key={star}
                                            className={`cursor-pointer text-[25px] ${
                                            star <= rating ? "text-[#290A69]" : "text-[#A1A3EF]"
                                            }`}
                                            onClick={() => setRating(star)}
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="w-full flex justify-between items-center">
                                <p className="text-[18px] text-[#290A69]">3. How punctual was your instructor for class.</p>
                                <div className="flex gap-[5px]">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <FaStar
                                            key={star}
                                            className={`cursor-pointer text-[25px] ${
                                            star <= rating ? "text-[#290A69]" : "text-[#A1A3EF]"
                                            }`}
                                            onClick={() => setRating(star)}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div> */}